import { forwardRef, useEffect, useState, type FC } from "react";
import { Button, Form, Input, Modal } from "rsuite";
import { ProductAttribute } from "../../../models/inventory/product_attribute";

interface ProductAttributeFormProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: ProductAttribute) => void;
  productAttribute?: ProductAttribute;
}

const ProductAttributeForm: FC<ProductAttributeFormProps> = ({
  open,
  onClose,
  onSubmit,
  productAttribute,
}) => {
  const [data, setData] = useState<ProductAttribute>({
    id: "",
    name: "",
    priority: 0,
  });
  
  useEffect(() => {
    setData(
      productAttribute || {
        id: "",
        name: "",
        priority: 0,
      }
    );
  }, [productAttribute]);
  return (
    <Modal size={"lg"} open={open} onClose={onClose}>
      <Modal.Header>Product Attribute Form</Modal.Header>
      <Modal.Body>
        <div className="w-full">
          <div className="form-group">
            <label>Name</label>
            <Input
              name="name"
              placeholder="Name"
              value={data.name}
              onChange={(value, event) => setData({ ...data, name: value })}
            />
          </div>
          <div className="form-group">
            <label>Priority</label>
            <Input
              type="number"
              name="priority"
              placeholder="Priority"
              value={data.priority}
              onChange={(value, event) =>
                setData({ ...data, priority: Number(value) })
              }
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="pt-4">
          <Button appearance="primary" onClick={() => {
            onSubmit(data!)
            setData({
              id: "",
              name: "",
              priority: 0,
            })
            }}>
            Submit
          </Button>
          <Button appearance="link" onClick={onClose}>
            Cancel
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
export default ProductAttributeForm;
